<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    json: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['close']);
</script>

<template>
    <Teleport to="body">
        <div v-if="props.show" class="json-modal-overlay" @click="emit('close')">
            <div class="json-modal" @click.stop>
                <div class="json-modal__header">
                    <h3 class="json-modal__title">JSON Preview</h3>
                    <button class="json-modal__close" @click="emit('close')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="json-modal__body">
                    <pre><code>{{ JSON.stringify(props.json, null, 2) }}</code></pre>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="postcss">
.json-modal-overlay {
    @apply fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease;
}

.json-modal {
    @apply bg-white dark:bg-gray-800 rounded-xl shadow-xl overflow-hidden
           w-full max-w-4xl;
    min-height: min(600px, 90vh);
    max-height: 90vh;
    animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.json-modal__header {
    @apply flex items-center justify-between p-5 border-b border-gray-200 dark:border-gray-700
           sticky top-0 bg-white dark:bg-gray-800 z-10;
}

.json-modal__title {
    @apply text-lg font-medium text-gray-900 dark:text-white;
}

.json-modal__close {
    @apply text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 
           p-1.5 rounded-lg transition-colors
           hover:bg-gray-100 dark:hover:bg-gray-700;
}

.json-modal__body {
    @apply p-5 overflow-auto;
    height: calc(100% - 70px);
}

.json-modal__body pre {
    @apply text-sm text-gray-800 dark:text-gray-200
           whitespace-pre-wrap break-words;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideIn {
    from {
        transform: translateY(20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@media (max-width: 640px) {
    .json-modal {
        @apply m-0;
        min-height: 100vh;
        max-height: 100vh;
        border-radius: 0;
    }

    .json-modal-overlay {
        @apply p-0;
    }
}
</style> 